import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Custom
import { cpmParkingCategoryDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';
import ParkingCategoryIcon from './ParkingCategoryIcon';
import ParkingCategoryTitle from './ParkingCategoryTitle';

const ParkingCategoryAltItem = ({ parkingCategory, light }) => (
  <InformationItem
    light={light}
    label={<LocalizedMessage id="field.parkingCategory" />}
    value={<ParkingCategoryTitle parkingCategory={parkingCategory} />}
    customIcon={<ParkingCategoryIcon parkingCategory={parkingCategory} />}
  />
);

ParkingCategoryAltItem.propTypes = {
  parkingCategoryId: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  parkingCategory: cpmParkingCategoryDataShape.isRequired,
  light: PropTypes.bool,
};

ParkingCategoryAltItem.defaultProps = {
  light: false,
};

const mapStateToProps = (state, ownProps) => ({
  parkingCategory: _find(state.cpmCarparkParkingCategory.list.elements, ['id', ownProps.parkingCategoryId]),
});

module.exports = connect(
  mapStateToProps,
)(ParkingCategoryAltItem);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkingCategories/ParkingCategoryAltItem.js